const { createSelector } = require('reselect')

const selectPlanList = state => state.plan.planList
const getPlanList = () => createSelector(
  [selectPlanList],
  cse => cse.data,
)
const getPlanListError = () => createSelector(
  [selectPlanList],
  cse => cse.error,
)
const getPlanListLoading = () => createSelector(
  [selectPlanList],
  cse => cse.loading,
)

const selectPlan = state => state.plan.plan
const getPlan = () => createSelector(
  [selectPlan],
  cse => cse.data,
)
const getPlanError = () => createSelector(
  [selectPlan],
  cse => cse.error,
)
const getPlanLoading = () => createSelector(
  [selectPlan],
  cse => cse.loading,
)

const selectCreate = state => state.plan.create
const getCreatePlan = () => createSelector(
  [selectCreate],
  cse => cse.data,
)
const getCreatePlanError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)
const getCreatePlanLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)

const selectUpdate = state => state.plan.update
const getUpdatePlan = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)
const getUpdatePlanError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)
const getUpdatePlanLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)

const selectDelete = state => state.plan.delete
const getDeletePlan = () => createSelector(
  [selectDelete],
  cse => cse.data,
)
const getDeletePlanError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)
const getDeletePlanLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

const selectPlanForPriceState = state => state.plan.getPlanForPriceState
const getPlanForPrice = () => createSelector(
  [selectPlanForPriceState],
  cse => cse.data,
)
const getPlanForPriceError = () => createSelector(
  [selectPlanForPriceState],
  cse => cse.error,
)
const getPlanForPriceLoading = () => createSelector(
  [selectPlanForPriceState],
  cse => cse.loading,
)

module.exports = {
  getPlanList,
  getPlanListLoading,
  getPlanListError,
  getPlan,
  getPlanLoading,
  getPlanError,
  getCreatePlan,
  getCreatePlanLoading,
  getCreatePlanError,
  getUpdatePlan,
  getUpdatePlanLoading,
  getUpdatePlanError,
  getDeletePlan,
  getDeletePlanLoading,
  getDeletePlanError,
  getPlanForPrice,
  getPlanForPriceError,
  getPlanForPriceLoading,
}
